import React, { useEffect, useState } from 'react';
import NotFound from '../components/NotFound.tsx';
import { Role } from '../models/enums/role.ts';
import { useUsersContext } from './users.tsx';

export const AccessProvider = ({ children, roles }: { children: any, roles: Role[] }) => {
    const [hasAccess, setHasAccess] = useState<boolean>(false);
    const [hasRoleAccess, setHasRoleAccess] = useState<boolean>(false);
    const { userID, isInRole } = useUsersContext();

    const validateRole = () => {
        setHasRoleAccess(roles.some(r => isInRole(r)));
    }
    useEffect(() => {
        validateRole();
    }, [userID, roles])

    useEffect(() => {
        setHasAccess(hasRoleAccess)// add more validations with &&
    }, [hasRoleAccess])
    return (
        hasAccess ?
            children
            :
            <NotFound />
    )
}